var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 114,
    viewBox: "0 0 208 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.627686 21.2267H16.9762V113.071H207.653V62.0195H133.18V21.2267H147.47V0.425781H1.23821V0.721946H0.627686V21.2267ZM161.947 108.257H174.045H188.443H202.841V66.831H188.701V108.257H183.888V66.831H133.18V108.257H157.134V66.831H161.947V108.257ZM101.58 66.831V108.257H128.368V66.831H101.58ZM76.9634 66.831V108.257H96.7683V66.831H76.9634ZM72.152 69.0679V66.831H52.3339V108.257H72.1371V69.0679H72.152ZM21.7877 66.831V108.257H47.5208V66.831H21.7877ZM21.7877 51.6538V62.0195H47.5208V51.6538H21.7877ZM52.3339 51.6538V62.0195H72.152V51.6538H52.3339ZM76.9634 51.6538V62.0195H96.7683V51.6538H76.9634ZM101.58 51.6538V62.0195H128.368V51.6538H101.58ZM21.7877 46.8407H128.368V21.2267H21.7877V46.8407ZM5.44076 16.4153H142.659V5.23885H5.44076V16.4153Z",
    fill: "#255056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.925 46.753H207.653V51.5661H122.925V46.753Z",
    fill: "#255056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.84 97.9793V47.4769H207.653V97.9793H202.84Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.a88638ce544ef9416a30b5e60cc7fb6b.svg";
export { ForwardRef as ReactComponent };